<template>
    <div class="w-full">
        <div
            class="relative border-1 rounded-2xl min-w-full min-h-[60vh] 2xl:min-h-[80vh] flex flex-col mobile:gap-4 laptop:gap-2 px-2 pt-4 pb-5 border-gray-300">
            <div
                class="w-full flex mobile:flex-col laptop:flex-row laptop:justify-beween laptop:items-center mobile:gap-6 laptop:gap-2 mobile:px-1.5 laptop:px-2.5 mobile:-mt-[40px] laptop:-mt-[45px]">
                <!-- Active / Completed tabs removed (user, 21 Oct): on web the backend returns one list and the Status
                     filter (filter drawer next to Create Quote) picks the statuses -->
                <div class="mobile:hidden laptop:block laptop:w-[45%] largeDesktop:w-[60%]" />
                <div class="mobile:w-full laptop:w-[55%] largeDesktop:w-[40%] flex items-center justify-end gap-2">
                    <div class="mobile:hidden laptop:block">
                        <entities :model-value="limit" global-entities-class="" @update:model-value="onLimitChange" />
                    </div>
                    <searchInput v-model="search" :global-search-class="'mobile:w-full laptop:!w-[55%]'"
                        :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-[37px] largeDesktop:h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'"
                        :buttonclass="'absolute top-[4px] right-[4px] largeDesktop:top-1.5 largeDesktop:right-1 w-7 h-7'"
                        :img-src="require('@/assets/images/search-icon.png')"
                        :clear-class="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
                        :on-clear="onClearSearch" :readonly="loading" :clearable="true" @input="onSearch" />
                    <!-- "+": the same create flow as Create Quote → Service & Repair in the header (globaldashboardHead "fx-create");
                         hidden on an empty list, where the empty state has its own "+ Create" button -->
                    <button v-if="!isDealerForPartner && tableItems?.length" type="button" aria-label="Create Service & Repair"
                        class="min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] p-0 border-0 bg-transparent cursor-pointer"
                        @click="createNew(1)">
                        <img src="../../assets/images/add-iconRQ.png" alt="" class="w-full h-full object-contain">
                    </button>
                    <!-- list filters (count badge, filled while applied), last in the toolbar -->
                    <ListFilterButton />
                </div>
            </div>
            <!-- cards below 1280px: next to the side menu the table is wider than the page at 1024 (QA D-28) -->
            <div class="desktop:hidden block">
                <div v-if="tableItems.length > 0" class="mt-2">
                    <serviceRepairListing v-for="(item, index) in tableItems" :key="index" :item="item" />
                </div>
                <div v-else>
                    <EmptyState v-if="tableItems == null || (tableItems && tableItems.length == 0)" min-height="min-h-[60vh]">
                        <button v-if="!isDealerForPartner" type="button" class="fxBtnPrimary mt-[8px]" @click="createNew(1)">+ Create Service & Repair</button>
                    </EmptyState>
                </div>
            </div>
            <div class="mt-2 desktop:block mobile:hidden">
                <serviceTable :table-headers="tableHeaders" :table-data="tableItems" :sort-clicked="sortClicked">
                    <template #empty><button v-if="!isDealerForPartner" type="button" class="fxBtnPrimary mt-[8px]" @click="createNew(1)">+ Create Service & Repair</button></template>
                </serviceTable>
            </div>
        </div>
        <div v-if="tableItems && tableItems.length > 0"
            class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
            <paginationEntries class="mobile:hidden tablet:block" :current-page="page" :per-page="limit"
                :total-items="totalItems" />
            <customPagination :page="page" :total_pages="total_pages" :update-page="updatePage" />
        </div>
    </div>
</template>

<script>
import EmptyState from "@/components/partialComponent/EmptyState.vue";
import ListFilterButton from "@/components/partialComponent/ListFilterButton.vue";
import { mapActions, mapGetters } from "vuex";
import entities from "../../components/showEntities/entities.vue";
import searchInput from '../../components/partialComponent/customInput.vue';
import serviceTable from '../../components/workOrder/serviceRepairTable.vue';
// import createQoute from "../../components/createQuote/createQuote.vue";
import serviceRepairListing from '../../components/workOrder/serviceRepairListing.vue';
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import listQueryState from "../../helpers/listQueryState";

export default {
    components: { EmptyState,
        ListFilterButton,
        entities,
        searchInput,
        serviceTable,
        serviceRepairListing,
        customPagination,
        paginationEntries
    },
    mixins: [listQueryState],
    data() {
        return {
            limit: 25,
            search: "",
            page: 1,
            total_pages: 0,
            totalItems: 0,
            debounceTimer: null,
            loading: false,
            tableHeaders: [],
            tableItems: [],
            selectedSort: {
                "column": "id",
                "direction": "DESC"
            },
        }
    },
    computed: {
        // the header hides "Service & Repair" create for a partner's dealer; so does the "+"
        isDealerForPartner() {
            return !!Number(this.userObject?.user?.is_dealer_for_partner);
        },
        ...mapGetters([
            "serviceRepairListing",
            "userObject",
        ]),
    },
    watch: {
        serviceRepairListing: function (data) {
            this.loading = false
            this.tableItems = this.serviceRepairListing.body
            this.total_pages = this.serviceRepairListing.paging.total_pages
            this.totalItems = this.serviceRepairListing.paging.total_records
            this.fixListPage()
        },
    },
    mounted() {
        this.setTableHeaders();
        this.restoreListState();
        this.fetchList();
    },
    methods: {
        createNew(item) {
            window.dispatchEvent(new CustomEvent("fx-create", { detail: item }));
        },
        ...mapActions([
            "getserviceRepairListing",
        ]),
        // every list load goes through here (keeps the sort and saves the state in the URL)
        fetchList() {
            this.loading = true
            this.getserviceRepairListing({
                // ignored on web (one list, statuses via the filter); still sent for the old backend's required rule
                status: 8,
                search: this.search,
                limit: this.limit,
                page: this.page,
                sort: this.selectedSort,
                ...this.listFilterParams,
            });
            this.saveListState()
        },
        updatePage(page) {
            if (page == this.page) return
            this.page = page
            this.fetchList()
            this.$nextTick(() => {
                document.documentElement.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            });
        },
        onSearch() {
            clearTimeout(this.debounceTimer);

            this.page = 1
            this.debounceTimer = setTimeout(() => {
                if (this.search.length == 0 || this.search.trim().length > 0) {
                    this.fetchList()
                }
            }, 1000);
        },
        onClearSearch() {
            clearTimeout(this.debounceTimer);
            this.page = 1
            this.search = ''
            this.fetchList()
        },
        onLimitChange(newLimit) {
            this.limit = newLimit;
            this.page = 1;
            this.fetchList();
        },
        setTableHeaders() {
            this.tableHeaders = [
                this.getTableHeaderObject("Booking ID", "id", "id", "", "1"),
                this.getTableHeaderObject("Job Type", "type", "type", "", "1"),
                this.getTableHeaderObject("Consumer Name", "consumer_name", "consumer_name", "", "1"),
                this.getTableHeaderObject("Date", "booking_date", "booking_date", "", "1"),
                this.getTableHeaderObject("Status", "status_text", "status_text", "", ""),
            ]
            this.setSort()
        },
        getTableHeaderObject(title, data_value, sort_column, sort_direction, sort_applicable, isHeaderToolTipShow = 0, tooltip_text = '') {
            return {
                title: title,
                data_value: data_value,
                sort_column: sort_column,
                sort_direction: sort_direction,
                sort_applicable: sort_applicable,
                isHeaderToolTipShow: isHeaderToolTipShow,
                tooltip_text: tooltip_text
            }
        },
        setSort() {
            this.tableHeaders.map(obj => {
                if (obj.sort_column == this.selectedSort.column) {
                    obj.sort_direction = this.selectedSort.direction;
                } else {
                    obj.sort_direction = "";
                }
            });
        },
        sortClicked(item) {
            if (item.sort_applicable == '1') {
                this.page = 1
                if (item.sort_column == this.selectedSort.column) {
                    this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
                    item.sort_direction = this.selectedSort.direction
                } else {
                    this.tableHeaders.map(obj => {
                        obj.sort_direction = "";
                    });
                    this.selectedSort.column = item.sort_column
                    this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
                    item.sort_direction = this.selectedSort.direction
                }
                this.fetchList()
            }
        },
    },
};
</script>